import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { restURL } from "../../../Models/restURL";
import { mdlProposalAddCompRenewalRes } from "../../../Models/mdlProposalAddCompRenewalRes";
import { mdlPremiumAndVehicleInfoCompRenewalRes } from "../../../Models/mdlPremiumAndVehicleInfoCompRenewalRes";

import { LanguageService } from './../../../Services/languageService';
import { Subscription } from "rxjs";
import Swal from 'sweetalert2';
import { mdlPayFortRequestDetailsReq } from "../../../Models/mdlPayFortRequestDetailsReq";
import { mdlPayFortRequestDetailsRes } from "../../../Models/mdlPayFortRequestDetailsRes";
import { ProposalModel } from "../../../Models/ProposalModel";
import { mdlSadadBillerReq } from "../../../Models/mdlSadadBillerReq";
import { mdlSadadBillerRes } from "../../../Models/mdlSadadBillerRes";
import { userService } from "../../../Services/userService";
import { motorProposalService } from "../../../Services/motorProposalService";
import { mdlPayloadRequest } from "../../../Models/mdlPayloadRequest";
import { mdlPayloadResponse } from "../../../Models/mdlPayloadResponse";
//import { ActivatedRoute, RouterStateSnapshot } from "@angular/router";
@Component({
    selector: 'PayfortPaymentNew',
    templateUrl: './PayfortPaymentNew.html',
    styleUrls: ['./PayfortPaymentNew.css']
})
export class PayfortPaymentNew {
    public isShowLoading: boolean = false;
    public agreeTerms: boolean = false;
    public Lng: string;
    public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    public LngSubscription: Subscription;
    public objAddProposalRes: mdlProposalAddCompRenewalRes = new mdlProposalAddCompRenewalRes();
    public proposalObj: ProposalModel = new ProposalModel();
    public objPremiumAndVehicleInfoRes: mdlPremiumAndVehicleInfoCompRenewalRes = new mdlPremiumAndVehicleInfoCompRenewalRes();
    public objmdlPayFortRequestDetailsReq: mdlPayFortRequestDetailsReq = new mdlPayFortRequestDetailsReq();
    public objmdlPayFortRequestDetailsRes: mdlPayFortRequestDetailsRes = new mdlPayFortRequestDetailsRes();
    public PaymentType: string;
    public PaymentDate;
    public RegNo: string;

    public objGenerateBillReq: mdlSadadBillerReq = new mdlSadadBillerReq();
    public objGenerateBillRes: mdlSadadBillerRes = new mdlSadadBillerRes();
    public BillExpiryDate: string;
    public BillExpiryTime: string;
    public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
    public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();

    constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private userinfo: userService, public url: restURL, private lngService: LanguageService) {
        this.agreeTerms = false;
        this.LngSubscription = this.lngService.grtLng().subscribe(lng => {
            this.Lng = lng
        });

        if (sessionStorage.getItem("Language") != null) {
            this.Lng = sessionStorage.getItem("Language");
        }
        else {
            this.Lng = "en";
        }
        this.RegNo = sessionStorage.getItem("RegNo");
        this.BindInfo();
    }



    goCancel() {
        this.router.navigate(['/NewDashboard/Proposals']);
    }


    ///<<<<<<<<<<<<<<<<<<TERMS AND CONDITIONS  START>>>>>>>>>>>>>>>>>


    public fncTermsAndConditions() {
        if (this.Lng == "en") {
            Swal("<img src='assets/img/Acig.png' class='acigimage' style='width: 25%;height: 25%;margin: 0 auto;'>", "<h5 style='color:green'>I / We declare that the information given in this proposal and all attachment to it are true and correct and includes all required information according to the relevant insurance terms, regulations and Fundamentals. I / We hereby authorized the Allied Cooperative Insurance Group (ACIG) to review all information including my/our credit record from other insurance companies and/or The Saudi Credit Bureau (SIMAH) and /or Najm for insurance services and any other party and in accordance with the rules of collection and exchange of insurance information for vehicles issued by SAMA and other related regulations and instructions ; I agree to grant Allied Cooperative Insurance Group (ACIG) the right to inquire from Najm Insurance Services Company for the insurance claims data for the vehicles to which I was a party, and I agree to grant Najm Insurance Services Company the right Collect and exchange insurance claims data for the vehicles to which you were a party, prior or future, with insurance, reinsurance companies or self-employed. I/ We agree that this proposal, together with any other information supplied by us shall form the basis of the insurance contract between us and Allied Cooperative Insurance Group (ACIG). Hence, we are bound by the information provided and its veracity.</h5> ", "info");
        }
        else {
            Swal("<img src='assets/img/Acig.png' class='acigimage' style='width: 25%;height: 25%;margin: 0 auto;'>", "<h5 style='color:green'>أقر أنا ( نحن ) ان المعلومات المذكورة اعلاه في هذا الطلب و في اي مرفقات بها هي حقيقية و صحيحة والمشتملة على كافة المعلومات المتطلبة وفق الأنظمة والتشريعات ذات العلاقة وأساسيات التأمين وأحكامها ، و إنني بموجب هذا الطلب أفوض شركة المجموعة المتحدة للتأمين التعاوني ( أسيج) بالإطلاع على كافة المعلومات بما فيها السجل الائتماني الخاصة بي ( بنا ) من شركات التأمين الأخرى و ( أو ) الشركة السعودية للمعلومات الائتمانية (سمه) و ( أو ) شركة نجم للخدمات التأمينية و اي جهة اخرى و وفقاً لقواعد جمع وتبادل المعلومات التأمينية للمركبات الصادرة عن مؤسسة النقد العربي واللوائح والتعليمات الأخرى ذات العلاقة ، أوافق على منح شركة التأمين الحق في الإستعلام من شركة نجم لخدمات التأمين عن بيانات المطالبات التأمينية للمركبات التي كنت طرفاً فيها ، وكذلك أوافق على منح شركة نجم لخدمات التأمين الحق بجمع وتبادل بيانات المطالبات التأمينية للمركبات التي كنت طرفاً فيها ، سابقة أو مستقبلية ، مع شركات التأمين أو إعادة التأمين أو أصحاب المهن الحرة. كما اقر انا ( نحن ) عـلى أن هذا الطلب و أي معلومات أخرى مقدمة من قبلنا تشكل أساسا لعقد التأمين بيننا و بين المجموعة المتحدة للتأمين التعاوني ( أسيج).</h5> ", "info");
        }
    }

    ///<<<<<<<<<<<<<<<<<<TERMS AND CONDITIONS  END>>>>>>>>>>>>>>>>>


    ///<<<<<<<<<<<<<<<<<<GET PAYFORT PAMENT REQUEST DETAILS START>>>>>>>>>>>>>>>>>

    public GetPamentRequestDetails() {
        if (!this.agreeTerms) {
            Swal("Please Check Agree terms Button");
            return;
        }
        if (this.PaymentType == "SDB") {
            this.GenerateBill();
        } else {
            sessionStorage.setItem("PaymentType", this.PaymentType);
            if (this.PaymentType == 'MD') {
                this.objmdlPayFortRequestDetailsReq.PaymentMethod = "CR";
            }
            this.objmdlPayFortRequestDetailsReq.ProposalNo = this.objAddProposalRes.PROPOSALNO ? this.objAddProposalRes.PROPOSALNO : this.proposalObj.ProposalNo;
            //this.objmdlPayFortRequestDetailsReq.PaymentMethod = this.PaymentType;
            this.objmdlPayFortRequestDetailsReq.Email_Id = this.objPremiumAndVehicleInfoRes.POLICY_INFO.Insured_EmailId ? this.objPremiumAndVehicleInfoRes.POLICY_INFO.Insured_EmailId : this.proposalObj.Email;
            this.objmdlPayFortRequestDetailsReq.Language = this.Lng;
            this.objmdlPayFortRequestDetailsReq.RegNo = this.RegNo;
            this.objmdlPayFortRequestDetailsReq.ProductCode = this.objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode ? this.objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode : this.proposalObj.ProductCode;
            this.isShowLoading = true;


            this.http.post<mdlPayFortRequestDetailsRes>(this.url.LimraOnlinePaymentsURL + "/OnlinePayments/GetPayFortRequestDetails", this.objmdlPayFortRequestDetailsReq, this.httpOptions).toPromise().then((objResponse) => {
                this.objmdlPayFortRequestDetailsRes = objResponse;
             
                this.isShowLoading = false;
                if (this.objmdlPayFortRequestDetailsRes.Status_Code == "0") {
                    Swal(this.objmdlPayFortRequestDetailsRes.ERROR_MSG);
                } else {
                    sessionStorage.setItem("objmdlPayFortRequestDetailsRes", JSON.stringify(this.objmdlPayFortRequestDetailsRes));
                    this.router.navigate(['/NewDashboard/PayfortConfirmNew']);
                }

            }, (error) => {
                this.isShowLoading = false;
                Swal("", "<h4 style='color:red'>" + JSON.stringify(error) + "</h4> ", "error");
            });
        }



    }


    ///<<<<<<<<<<<<<<<<<<GET PAYFORT PAMENT REQUEST DETAILS END>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

    //<<<<<<<<<<<BIND INFO START>>>>>>>>>>>>>

    public BindInfo() {

        let UrlString = this.router.routerState.snapshot.url.split(":");
        let UrlRedirectType = UrlString[1];
        if (UrlRedirectType == "Confirm") {

            //this.objAddProposalRes = JSON.parse(sessionStorage.getItem("objAddProposalRes"));
            this.objAddProposalRes = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("objAddProposalRes")));
            //this.objPremiumAndVehicleInfoRes = JSON.parse(sessionStorage.getItem("objPremiumAndVehicleInfoRes"));
            this.objPremiumAndVehicleInfoRes = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("objPremiumAndVehicleInfoRes")));

            if (this.objAddProposalRes.INSURED_NAME == null || this.objAddProposalRes.INSURED_NAME == "") {

                this.objAddProposalRes.INSURED_NAME = this.objPremiumAndVehicleInfoRes.POLICY_INFO.Insured_Name;
                //sessionStorage.setItem("objAddProposalRes", JSON.stringify(this.objAddProposalRes));
                sessionStorage.setItem("objAddProposalRes", this.EncriptService.EncriptObject(JSON.stringify(this.objAddProposalRes)));
            }
        }
        else if (UrlRedirectType == "DashBoard") {
            //this.proposalObj = JSON.parse(sessionStorage.getItem("paymentObj"));
            this.proposalObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("paymentObj")));
            this.objAddProposalRes.INSURED_NAME = this.proposalObj.transObj.InsuredName;
            this.objAddProposalRes.PROPOSALNO = this.proposalObj.ProposalNo;
            this.objAddProposalRes.TOTAL_PREMIUM = this.proposalObj.TotalPremium;
        }
    }

    //<<<<<<<<<<<BIND INFO END>>>>>>>>>>>>>



    GenerateBill() {
        this.objGenerateBillReq.ProposalNo = this.objAddProposalRes.PROPOSALNO ? this.objAddProposalRes.PROPOSALNO : this.proposalObj.ProposalNo;
        this.objGenerateBillReq.RegNo = this.RegNo;
        this.objGenerateBillReq.ProductCode = this.objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode ? this.objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode : this.proposalObj.ProductCode;
        this.objGenerateBillReq.Token = this.userinfo.getToken();
        this.objGenerateBillReq.Lang = sessionStorage.getItem("Language")
        this.isShowLoading = true;

        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objGenerateBillReq));

        //this.http.post<mdlSadadBillerRes>(this.url.baseURL + "/Payfort/GenerateBill", this.objGenerateBillReq, this.userinfo.getHttpOptions())
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Payfort/GenerateBill", this.objPayloadRequest, this.userinfo.getHttpOptions())
            .toPromise().then((result) => {
                this.isShowLoading = true;
                //this.objGenerateBillRes = result;

                //New Line Start
                this.objPayloadResponse = result;
                this.objGenerateBillRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
                //NewLine End

                if (this.objGenerateBillRes.StatusCode == "S") {
                    this.BillExpiryDate = this.objGenerateBillRes.BillExpiryDate.split("T")[0];
                    this.BillExpiryTime = this.objGenerateBillRes.BillExpiryDate.split("T")[1];
                    if (sessionStorage.getItem("Language") == "en")
                        Swal("You can pay before " + this.BillExpiryDate + " " + this.BillExpiryTime + ", by selecting the company code 196 via SADAD system");
                    else
                        //swal(" باختيار رمز الشركة 196 عبر نظام سداد،" + " " + this.BillExpiryTime + " " + this.BillExpiryDate + " " + " يمكنكم السداد قبل " + this.objGenerateBillRes.BillNo + " تم إصدار فاتورة سداد");

                        Swal(" تم إصدار فاتورة سداد" + "  " + this.objGenerateBillRes.BillNo + "   " + " يمكنكم السداد قبل " + " " + this.BillExpiryDate + " " + this.BillExpiryTime + "</b> " + " باختيار رمز الشركة 196 عبر نظام سداد،");
                    this.router.navigate(['/NewDashboard/Proposals']);

                } else {
                    Swal(this.objGenerateBillRes.StatusDesc);
                }

            }, (error) => {
                this.isShowLoading = false;
                Swal("Invalid!,Please try again later");
            });

    }




}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/PayfortNew/PayfortPaymentNew/PayfortPaymentNew.ts